/**
 * Platform administration API endpoints
 */

import { fetchApi } from '../core';
import type {
  CreateTenantData,
  SystemSettingsResponse,
  TenantResponse,
  UpdateTenantPlanData,
  UpdateTenantProfileData,
  UpdateSystemSettingsData,
  UpdateTenantSettingsData,
  UpdateTenantStatusData,
} from '../types';

export function listTenants(componentName: string = 'Unknown') {
  return fetchApi<TenantResponse[]>('/platform/tenants', {}, componentName);
}

export function createTenant(data: CreateTenantData, componentName: string = 'Unknown') {
  return fetchApi<TenantResponse>('/platform/tenants', {
    method: 'POST',
    body: JSON.stringify(data),
  }, componentName);
}

export function getTenant(tenantId: string, componentName: string = 'Unknown') {
  return fetchApi<TenantResponse>(`/platform/tenants/${tenantId}`, {}, componentName);
}

export function updateTenant(
  tenantId: string,
  data: UpdateTenantProfileData,
  componentName: string = 'Unknown'
) {
  return fetchApi<TenantResponse>(`/platform/tenants/${tenantId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }, componentName);
}

export function updateTenantStatus(
  tenantId: string,
  data: UpdateTenantStatusData,
  componentName: string = 'Unknown'
) {
  return fetchApi<TenantResponse>(`/platform/tenants/${tenantId}/status`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }, componentName);
}

/** Set a tenant's commercial plan (platform roles only; drives entitlements). */
export function updateTenantPlan(
  tenantId: string,
  data: UpdateTenantPlanData,
  componentName: string = 'Unknown'
) {
  return fetchApi<TenantResponse>(`/platform/tenants/${tenantId}/plan`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }, componentName);
}

export function updateTenantSettings(
  tenantId: string,
  data: UpdateTenantSettingsData,
  componentName: string = 'Unknown'
) {
  return fetchApi<TenantResponse>(`/platform/tenants/${tenantId}/settings`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }, componentName);
}

export function getSystemSettings(componentName: string = 'Unknown') {
  return fetchApi<SystemSettingsResponse>('/platform/settings', {}, componentName);
}

export function updateSystemSettings(
  data: UpdateSystemSettingsData,
  componentName: string = 'Unknown'
) {
  return fetchApi<SystemSettingsResponse>('/platform/settings', {
    method: 'PUT',
    body: JSON.stringify(data),
  }, componentName);
}
